export default "__VITE_ASSET__ec176dbe__"